import { EventEmitter } from 'vimmi-web-utils/cjs/eventEmitter';
import lifecycle from 'page-lifecycle';

const eventsSrv = new EventEmitter();

let eventsSubscribers = [];

export function subscribeByTarget(event, target, fn, ...options) {
  target.addEventListener(event, fn, ...options);
  eventsSubscribers.push({ event, fn, target, options });
}

export function offSubscribers() {
  eventsSubscribers.map((subscriber) => {
    subscriber.target.removeEventListener(subscriber.event, subscriber.fn);
  });
  eventsSubscribers = [];
}

export default eventsSrv;

